import FadedText from "@components/FadedText";
import { Column, LineClamp } from "@components/Layout";
import { Template } from "@components/Template";
import { playerContext } from "@layouts/App/context/Player";
import { Show, createMemo, useContext } from "solid-js";
import TrackControls from "./components/PlayerControls";
import RadialTrackControl from "./components/RadialTrackControl";

const Player = () => {
	const { player } = useContext(playerContext);

	const track = createMemo(() => player.queue[player.track]);

	return (
		<Column>
			<RadialTrackControl />
			<Column padding="20px 0" alignItems="center">
				<Show
					when={track()}
					fallback={
						<Show when={player.loading}>
							<Template h="20px" w="50%" borderRadius="5px" />
							<Template h="15px" w="20%" borderRadius="5px" margin="5px 0 0" />
						</Show>
					}
				>
					<h3 class={LineClamp} style={{ "text-align": "center" }}>
						{track().name}
					</h3>
					<FadedText textAlign="center" class={LineClamp} fontSize="13px">
						{track().author}
					</FadedText>
				</Show>
			</Column>
			<TrackControls />
		</Column>
	);
};
export default Player;
